import styled from 'styled-components/macro';

export const ListItemWrapper = styled.div`
  position: relative;
  background-color: #FFFFFF;
  color: #839393;
  padding: 20px 28px 20px 23px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin-bottom: 4px;

  @media (max-width: 575px) {
    padding: 19px 18px;
    margin-bottom: 18px;
  }

  .avatar-wrapper {
    position: relative;
    width: 53px;
    height: 53px;
    border-radius: 8px;

    img {
      width: 100%;
      border-radius: 8px;
    }

    @media (max-width: 575px) {
      width: 69px;
      height: 69px;
    }
  }

  .info-wrapper {
    @media (max-width: 575px) {
      margin-top: 20px;

      small {
        float: right;
      }
    }
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #F3F7FA;
    border-radius: 12px;
    position: absolute;
    top: 13px;
    right: 12px;
  }

  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #1D1D1D;
    margin-bottom: 2px;

    @media (max-width: 575px) {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 3px;
    }
  }

  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;

    @media (max-width: 575px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  p {
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    color: #000000;
    margin: 10px 0 0;
  }

  button {
    padding: 6px 17px;
    font-size: 13px;
    font-weight: 400;
  }
`;